import { render, staticRenderFns } from "./tMobile.vue?vue&type=template&id=8f7755e0&scoped=true&"
import script from "./tMobile.vue?vue&type=script&lang=ts&"
export * from "./tMobile.vue?vue&type=script&lang=ts&"
import style0 from "./tMobile.vue?vue&type=style&index=0&id=8f7755e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7755e0",
  null
  
)

export default component.exports